import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { resolveLeagueAccess } from "../access/leaguePermissions";

export default function LeaguePermissionGate({ permission, children }) {
  const auth = useAuth();
  const { permissions } = resolveLeagueAccess({ ...(auth?.member || {}), claims: auth?.claims || {} });
  // League authorization is intentionally independent from the organisation
  // member role and from Morpheus profiles. Only the explicit Matrix League role
  // and permissions may grant access to a League action.
  if (!permissions?.[permission]) return <Navigate to="/league" replace />;
  return children;
}
